import { AggregatedLineItemGroup } from 'Invoices/types'

export const totalQuantityForGroup = (
  lineItemGroup: AggregatedLineItemGroup
) => {
  return lineItemGroup.lineItems.reduce(
    (acc, lineItem) => acc + Number(lineItem.quantity),
    0
  )
}
